import { Empty, Spin } from "antd";
import { useDocuments } from "../../../../../hooks/useDocuments";
import { useInfiniteScroll } from "../../../../../hooks/useInfiniteScroll";
import { StyledDocuments } from "./styles";
import { useMemo } from "react";
import { formatFileSize } from "../../../../../utils/shared";
import DocItem from "./DocItem";

const Documents = () => {
  const {
    docs,
    hasMore,
    loading,
    fetchDocs,
    selectedTenantId,
    selectedChatId,
  } = useDocuments();

  const sentinelRef = useInfiniteScroll({
    loading,
    hasMore,
    onLoadMore: fetchDocs,
  });

  const groupedByDate = useMemo(() => {
    const groups = {};
    docs.forEach((file) => {
      const date = new Date(file.uploaded_at);
      const dateKey = date?.toLocaleDateString("en-US", {
        day: "numeric",
        year: "numeric",
        month: "long",
      });
      if (!groups[dateKey]) {
        groups[dateKey] = [];
      }

      const type = file?.mime_type?.split("/")?.pop() || file?.mime_type;

      groups[dateKey].push({
        ...file,
        meta: `${formatFileSize(file.file_size_bytes)} • ${file?.mime_type}`,
        type,
      });
    });
    return Object.entries(groups).sort(
      // @ts-ignore
      (a, b) => new Date(b[0]) - new Date(a[0]),
    );
  }, [docs]);

  return (
    <StyledDocuments>
      {!loading && docs?.length === 0 && (
        <Empty description="No documents found" />
      )}
      {groupedByDate.map(([dateKey, files]) => (
        <div key={dateKey} className="date-group">
          <div className="date-header">{dateKey}</div>

          <div className="files-list">
            {files.map((file) => (
              <DocItem
                file={file}
                selectedTenantId={selectedTenantId}
                selectedChatId={selectedChatId}
              />
            ))}
          </div>
        </div>
      ))}
      {loading && (
        <div className="w-100 flex justify-center  ">
          <Spin />
        </div>
      )}
      {hasMore && <div ref={sentinelRef} style={{ height: "1px" }} />}
    </StyledDocuments>
  );
};

export default Documents;
